import React, { useState } from 'react'
import './Styles.scss'

const Dashboard: React.FC = () => {
    return (
      <div className='galaxy-container'>
        <div className="MuiBox-root css-gdkq0u">
          <div className="first-layer animate-rotate-reverse MuiBox-root css-0"><img src="images/moon-sign-inner.webp" alt="" className="img-responsive" /></div>
          <div className="second-layer animate-rotate MuiBox-root css-0"><img src="images/moon-sign-outer.webp" alt="" className="img-responsive" /></div>
          <div className="third-layer MuiBox-root css-15izq18"><img src="images/moon-inverse.webp" alt="about" className="img-responsive" /></div>
        </div>
      </div>
    )
}
export default Dashboard